import { onboarding } from '@services';

interface IRequest {
  studioId: string;
  fileId: string;
}

interface IRunImpoerterResponse {
  status: number;
}

const runImporter = async ({
  studioId,
  fileId,
}: IRequest): Promise<IRunImpoerterResponse> => {
  const data: IRunImpoerterResponse = await onboarding.get(
    `/api/v1/import/direct?studioId=${studioId}&fileId=${fileId}`,
  );
  return data;
};

const deleteImporter = async ({
  studioId,
  fileId,
}: IRequest): Promise<void> => {
  await onboarding.delete(
    `/api/v1/import?studioId=${studioId}&fileId=${fileId}`,
  );
};

export { runImporter, deleteImporter };
